export const modalConst = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  SET_UPLOADED_FILE_TYPE: 'SET_UPLOADED_FILE_TYPE',
};
